import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailSize } from '../../types/image-thumbnail-size';
import { AssetImageUrlPipe } from '../../pipes/asset-image-url.pipe';
import { AssetImage } from '../../enums/asset-image';
import { ImageThumbnailComponent } from '../image-thumbnail/image-thumbnail.component';

@Component({
  selector: 'app-image-thumbnail-unsupported',
  imports: [AssetImageUrlPipe, ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './image-thumbnail-unsupported.component.html',
  styleUrl: './image-thumbnail-unsupported.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageThumbnailUnsupportedComponent {
  public readonly size = input<ImageThumbnailSize>('default');
  public readonly rounded = input<boolean>(true);

  protected readonly AssetImage = AssetImage;
}
